import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'

const PersonRepository = RepositoryFactory.get('person')

class PersonService {
  static async createPerson (userId, data) {
    try {
      return await PersonRepository.createPerson(userId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updatePerson (userId, personId, data) {
    try {
      return await PersonRepository.updatePerson(userId, personId, data)
    } catch (error) {
      console.log(error)
    }
  }
}

export default PersonService
